<template>
  <div class="page-wrapper">
    <div style="width: 100%; height: 100%; display: flex;">
      <div style="width: 300px; height: 100%; overflow-y: auto;padding:10px;background-color: white;">
        <ul class="list-group">
          <li class="list-group-item hover-item" v-for="(a, ai) in items" v-bind:class="{'report-selected': item != false && item.id == a.id}" v-on:click="openAirline(a)">{{a.title}}</li>
        </ul>
      </div>
      <div style="width: calc(100% - 300px); height: 100%; display: flex;" v-if="item != false">
        <div style="width: 50%; height: 100%;" >
          <div style="width: 100%; height: 50px; line-height: 50px; text-align: right; padding-right: 20px; padding-left: 20px;">
            <button v-if="item.edit == false" class="btn btn-success" v-on:click="item.edit = true"><i class="fas fa-edit"></i> EDIT</button>
            <button v-if="item.edit == true" class="btn btn-dark" v-on:click="item.edit = false"><i class="fas fa-times"></i> CANCEL</button>

          </div>
          <div style="width: 100%; height: calc(100% - 100px); overflow-y: auto;">
            <div class="container">
              <div class="row input-row">
                <div class="col-12">
                  <label>Title</label>
                  <input type="text" class="form-control" v-model="item.title" placeholder="Title" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Description</label>
                  <input type="text" class="form-control" v-model="item.description" placeholder="Description" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Address</label>
                  <div style="width: 100%; height: unset;">
                    <input type="text" class="form-control" v-model="item.address1" placeholder="Line 1" :disabled="item.edit==false"/>
                    <input type="text" class="form-control" v-model="item.address2" placeholder="Line 2" :disabled="item.edit==false"/>
                    <input type="text" class="form-control" v-model="item.address3" placeholder="Line 3" :disabled="item.edit==false"/>
                    <input type="text" class="form-control" v-model="item.postCode" placeholder="POST CODE" :disabled="item.edit==false"/>
                    <input type="text" class="form-control" v-model="item.country" placeholder="South Korea" :disabled="item.edit==false"/>
                  </div>
                </div>
                <div class="col-12">
                  <label>Email</label>
                  <input type="text" class="form-control" v-model="item.email" placeholder="Email" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Telephone</label>
                  <input type="text" class="form-control" v-model="item.telephone" placeholder="Telephone" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>FAX</label>
                  <input type="text" class="form-control" v-model="item.fax" placeholder="Fax" :disabled="item.edit==false"/>
                </div>

                <div class="col-12">
                  <label>Flight Name Prefix</label>
                  <input type="text" class="form-control" v-model="item.flightNamePrefix" placeholder="KE" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Airline Code</label>
                  <input type="text" class="form-control" v-model="item.airlineCode" placeholder="180" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Account</label>
                  <input type="text" class="form-control" v-model="item.account" placeholder="Fax" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Airport of Departure</label>
                  <input type="text" class="form-control" v-model="item.airportDeparture" placeholder="Fax" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Airport of Destination</label>
                  <input type="text" class="form-control" v-model="item.airportDestination" placeholder="Fax" :disabled="item.edit==false"/>
                </div>
                <div class="col-12">
                  <label>Default TO code (ICN)</label>
                  <input type="text" class="form-control" v-model="item.toCode" placeholder="Fax" :disabled="item.edit==false"/>
                </div>
              </div>
            </div>
          </div>
          <div style="width: 100%; height: 50px; text-align: right; padding-right: 20px; padding-left: 20px;">
            <button v-if="item.edit == true" class="btn btn-primary" v-on:click="updateAirline"><i class="fas fa-save"></i> SAVE</button>
          </div>
        </div>
        <div style="width: 50%; height: 100%;">
          <div class="container">
            <div class="row">
              <div class="col-12 section-header-no-margin">MAWB List</div>
            </div>
          </div>
          <div style="width: 100%; height:calc(100% - 40px); overflow-y: auto;">
            <div class="container"  v-if="newAwb == false && item.id > 0">
              <div class="row">
                <div class="col-12">
                  <button class="btn btn-success" @click="showNewMawbForm">Add New Master Airway Bill Numbers</button>
                </div>
              </div>
            </div>
            <div class="container" style="margin-top:20px;"  v-if="newAwb != false">
              <div class="row">
                <div class="col-6">FROM</div>
                <div class="col-6">TO</div>
              </div>
              <div class="row">
                <div class="col-2 text-right">
                  <label class="form-control">{{newAwb.airlineCode}} -</label>
                </div>
                <div class="col-4">
                  <input class="form-control" v-model="newAwb.from"/>
                </div>
                <div class="col-2 text-right">
                  <label class="form-control">{{newAwb.airlineCode}} -</label>
                </div>
                <div class="col-4">
                  <input class="form-control" v-model="newAwb.to"/>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button class="btn btn-dark" style="margin-right: 30px;" v-on:click="newAwb = false">Cancel</button>
                  <button class="btn btn-primary" @click="submitNewAwbs">Submit</button>
                </div>
              </div>
            </div>
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <table class="table">
                    <tbody v-for="(mawb, mi) in item.mawbList" :key="'mawb-item-' + mawb.id">
                    <tr>
                      <td class="text-right">{{mi+1}}</td>
                      <td class="text-right">{{mawb.airlineCode}} - </td>
                      <td class="text-left">{{mawb.number}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="floating-button" style="bottom: 20px; left: 20px;" v-on:click="newAirline" v-if="item == false || item.id > 0">
      <i class="fas fa-plus"></i>
    </div>
  </div>
</template>

<script>
import {addMawbs, createNewAirline, getAirline, getAirlines, getMawbs, updateAirline} from "../api/airlines";
import {showDialog} from "../api/utils";

export default {
  name: "Airlines",
  data() {
    return{
      items:[],
      item:false,
      newAwb:false,
    }
  },
  created() {
  },
  mounted() {
    this.getAirlineList();
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    getAirlineList: function() {
      let self = this;
      getAirlines()
        .then(function(data) {
          if(data.success === true) {
            self.$data.items = data.item;
          }
        })
        .catch(function(err) {

        })
    },
    newAirline: function() {
      this.$data.item = false;
      this.$data.item = createNewAirline();
    },
    openAirline: function(item) {
      this.$data.item = false;
      let self = this;
      getAirline(item.id)
        .then(function(data) {
          if(data.success === true) {
            data.item.edit = false;
            self.$data.item = data.item;
            self.populateMawbs();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    updateAirline: function() {
      if(this.$data.item === false) {
        return;
      }

      let self = this;
      updateAirline(this.$data.item)
        .then(function(data) {
          if(data.success === true) {
            data.item.edit = false;
            self.$data.item = data.item;
            for(let i = 0 ; i < self.$data.items.length ; i++) {
              if(self.$data.items[i].id === data.item.id) {
                self.$data.items.splice(i, 1, data.item);
                return;
              }
            }
            self.$data.items.push(data.item);
            self.populateMawbs();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })

    },
    closeAirlineItem: function() {
      this.$data.item = false;
    },
    showNewMawbForm: function() {
      this.$data.newAwb = {
        airlineId: this.$data.item.id,
        airlineCode: this.$data.item.airlineCode,
        from:'',
        to:'',
      }
    },
    submitNewAwbs: function() {
      if(this.$data.newAwb.from == null || this.$data.newAwb.from.length !== 8) {
        showDialog("시작번호가 올바르지 않습니다.");
        return;
      }
      if(this.$data.newAwb.to == null || this.$data.newAwb.to.length !== 8) {
        showDialog("끝번호가 올바르지 않습니다.");
        return;
      }

      let self = this;
      addMawbs(this.$data.item.id, this.$data.newAwb.from, this.$data.newAwb.to)
        .then(function(data) {
          if(data.success === true) {
            self.$data.newAwb = false;
            self.populateMawbs();
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    populateMawbs: function() {
      if(this.$data.item == false) {
        return;
      }
      let self = this;
      self.$data.item.mawbList = [];
      getMawbs(this.$data.item.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.item.mawbList = data.item;
          }
        })
    }

  }

}
</script>

<style scoped>
.floating-button {
  position: fixed;
  width: 60px;
  height: 60px;
  background-color:#0C9;
  color: white;
  border-radius: 50%;
  text-align: center;
  box-shadow: 2px 2px 3px #999;
  font-size: 30px;
  line-height: 60px;
  transition: all 0.3s ease-in-out;
}
.floating-button:hover {
  font-size: 40px;
  background-color: #075700;
}
</style>



// WEBPACK FOOTER //
// src/components/Airlines.vue